<!-------------- ./ Datos cliente  ----------------->
<!------------------------------------------------>

<div class="container content">
    <div class="row">
        <div class="col-md-12">
            <div class="card mb-3">
                <div class="card-header">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <h6 class="subtitulo-pack2">
                                <b>Cliente</b>
                            </h6>
                        </div>
                    </div>
                </div>
                <div class="card-body bg-white">
                    <div class="row mt-4">
                        <div class="col-lg-8" *ngIf="user_data != null ">
                        <!-- Nombre cliente -->
                        <h5 class="title-list ms-3">
                            <b class="text-list">
                                {{user_data.firstName}}
                                {{user_data.surname1}}
                                {{user_data.surname2}}
                            </b>
                            <br><br>
                            <!-- Contacto -->
                            <span class="font-list">
                                <img src="./assets/img/phone.svg" class="img-fluid" width="13">
                                 Nº de contacto: <b>{{user_data.phone}}</b>
                            </span>
                            <br>
                            <!-- Tipo de alta -->
                            <span class="font-list">
                                <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                 Tipo de alta: <b>{{tipoAlta}}</b>
                                <b class="info-secundaria" *ngIf="getAdditionalLines() > 0">
                                    + {{ getAdditionalLines() }} línea(s) adicional(es)
                                </b>
                            </span>
                            <br>
                            <!-- MSISDN -->
                            <span class="font-list" *ngIf="msisdnMainLine() !== ''">
                                <img src="./assets/img/file-black.svg" class="img-fluid" width="13">
                                Línea móvil: <b>{{ msisdnMainLine() }}</b>
                            </span>
                            <br>
                            <!-- Fecha de solicitud -->
                            <span class="font-list">
                                <img src="./assets/img/clock.svg" class="img-fluid" width="13">
                                 Fecha de solicitud: <b>{{date | date:'dd/MM/yyyy':'UTC+1'}}</b>
                            </span>
                            <br>
                            <!-- Documento de identidad -->
                            <span class="font-list">
                                <img src="./assets/img/file.svg" class="img-fluid" width="13">
                                 {{ user_data.doctype }}: <b>{{user_data.doc}}</b>
                            </span>
                            <br>
                            <!-- Nº de contrato -->
                            <span class="font-list">
                                <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                 Nº de contrato: <b>{{contractId}}</b>
                            </span>
                            <!-- Terminal -->
                            <ng-container *ngFor="let item of getShoppingCart().getItems();">
                                <div *ngFor="let concept of item.concepts">
                                    <span class="font-list" *ngIf="concept.type === 'terminal'">
                                        <img src="./assets/img/smartphone2.svg" class="img-fluid" width="13">
                                         Terminal: <b>{{ concept.desc }}</b>
                                    </span>
                                </div>
                            </ng-container>

                            <!-- Comentarios -->
                            <span class="font-list" *ngIf="muestraComentarios">
                                 Comentarios: <b>-</b>
                            </span>
                            <br>
                        </h5>
                        </div>
                        <div align="right" id="cliente-tarifa-bubble" class="col-lg-4" >
                            <div class="col-lg-12 mb-2" *ngFor="let item of getShoppingCart().getItems();">
                                <span *ngFor="let concept of item.concepts">
                                    <span class="badge badge-pill badge-success font-list" *ngIf="concept.type === 'rate'">
                                        <span>
                                            {{ concept.desc }}: {{ concept.monthlyCost }} €
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
